import React, { Component } from 'react'
import { Dialog, Grid, Typography } from '@material-ui/core'
import { connect } from 'react-redux'
import { CustomButton } from '../../shared'
import { isMobileDevice, getBrowser } from '../../utils/helper'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { getContent } from '../../utils/helper'
import { USER_DENIED_LOCATION_CODE, USER_DENIED_MEDIA } from '../../utils/constant'

class CheckAppRequirement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLocationAllowed: localStorage.getItem('isLocationAllowed') === 'true' ? true : false,
            isCameraAllowed: localStorage.getItem('isCameraAllowed') === 'true' ? true : false,
            userDeny: false,
            isMobile: true,
            doesNotSupport: false,
            IOSUnsupportedBrowser: false,
            browserCapability: true,
            isIEBrowser: false,
            locationUrl: window.location.href
        }
    }

    componentDidMount = () => {
        let isMobile = isMobileDevice.any(), isIOS = isMobileDevice.iOS(), browser = getBrowser();
        if (!isMobile) {
            this.setState({ isMobile: false, doesNotSupport: true })
        } else if (isMobile && isIOS && browser !== 'Safari') {
            this.setState({ IOSUnsupportedBrowser: true, doesNotSupport: true })
        } else if (!navigator.geolocation || !navigator.mediaDevices) {
            this.setState({ browserCapability: false, doesNotSupport: true })
        } else if (browser === 'IE') {
            this.setState({ isIEBrowser: true, doesNotSupport: true })
        }
    }

    allowPermissions = () => {
        if (navigator.geolocation && navigator.mediaDevices) {
            navigator.geolocation.getCurrentPosition(() => {
                localStorage.setItem('isLocationAllowed', true);
                this.setState({ isLocationAllowed: true })
                navigator.mediaDevices
                    .getUserMedia({ audio: true, video: true })
                    .then((stream) => {
                        stream.getTracks().forEach(function (track) { track.stop() });
                        localStorage.setItem('isCameraAllowed', true);
                        this.setState({ isCameraAllowed: true })
                    }).catch((err) => {
                        if (err.name === USER_DENIED_MEDIA) {
                            localStorage.setItem('isCameraAllowed', false);
                            this.setState({ userDeny: true })
                        } else {
                            this.setState({ browserCapability: false, doesNotSupport: true })
                        }
                    })
            }, (err) => {
                if (err.code === USER_DENIED_LOCATION_CODE) {
                    localStorage.setItem('isLocationAllowed', false);
                    this.setState({ userDeny: true })
                } else {
                    this.setState({ browserCapability: false, doesNotSupport: true })
                }
            }, { enableHighAccuracy: true, maximumAge: 0 });
        } else {
            this.setState({ doesNotSupport: true })
        }
    }

    render() {
        const { isLocationAllowed, isCameraAllowed, userDeny, doesNotSupport, isIEBrowser,
            isMobile, IOSUnsupportedBrowser, browserCapability, locationUrl } = this.state
        const { languageJSON } = this.props
        return (
            !isLocationAllowed || !isCameraAllowed || doesNotSupport ?
                <Dialog onClose={() => { }} aria-labelledby="simple-dialog-title" open={true}>
                    {(!isLocationAllowed || !isCameraAllowed) && !doesNotSupport &&
                        <Grid container style={{ padding: '8px 20px 20px 20px' }}>
                            <Grid item xs={12} style={{ marginTop: 15 }}>
                            <Typography style={{ fontSize: 24, lineHeight: 1.2 }}>{getContent(languageJSON, 'title_allow_permission')}</Typography>
                            <Typography style={{ fontSize: 14, marginTop: 15, lineHeight: 1.5 }}>{getContent(languageJSON, 'subtitle_allow_permission')}</Typography>
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: 15 }}>
                                <Typography style={{ fontSize: 14, lineHeight: 1.5 }}>
                                    <ul>
                                    <li>{getContent(languageJSON, 'label_location_permission')}</li>
                                    <li>{getContent(languageJSON, 'label_camera_permission')}</li>
                                    </ul>
                                </Typography>
                            </Grid>
                            {userDeny && <Grid item xs={12} style={{ marginTop: 15, color: 'red' }}>
                            <Typography style={{ fontSize: 14 }}>{getContent(languageJSON, 'label_permission_deny')}</Typography>
                            </Grid>}
                            {!userDeny && <Grid item xs={12} style={{ marginTop: 15 }}>
                                <CustomButton
                                    size="large"
                                    variant="contained"
                                    style={{ textAlign: 'center', width: '100%' }}
                                    color="primary"
                                    handleChange={this.allowPermissions}
                                    label={getContent(languageJSON, 'action_allow')} />
                            </Grid>}
                        </Grid>}

                    {doesNotSupport && <Grid container style={{ padding: '8px 20px 20px 20px' }}>
                        {!isMobile && <Grid item xs={12} style={{ marginTop: 15 }}>
                            <Typography style={{ fontSize: 24 }}>{getContent(languageJSON, 'label_browser_not_supported')}</Typography>
                            <Typography style={{ fontSize: 14, marginTop: 15 }}>{getContent(languageJSON, 'label_desktop_not_supported')}</Typography>
                        </Grid>}
                        {IOSUnsupportedBrowser && <Grid item xs={12} style={{ marginTop: 15 }}>
                            <Typography style={{ fontSize: 24 }}>{getContent(languageJSON, 'label_browser_not_supported')}</Typography>
                            <Typography style={{ fontSize: 14, marginTop: 15 }}>{getContent(languageJSON, 'label_ios_unsupported_browser')}</Typography>
                        </Grid>}
                        {!browserCapability && <Grid item xs={12} style={{ marginTop: 15 }}>
                            <Typography style={{ fontSize: 24 }}>{getContent(languageJSON, 'label_browser_not_supported')}</Typography>
                            <Typography style={{ fontSize: 14, marginTop: 15 }}>{getContent(languageJSON, 'label_browser_capability_not_supported')}</Typography>
                        </Grid>}
                        {isIEBrowser && <Grid item xs={12} style={{ marginTop: 15 }}>
                            <Typography style={{ fontSize: 24 }}>{getContent(languageJSON, 'label_browser_not_supported')}</Typography>
                            <Typography style={{ fontSize: 14, marginTop: 15 }}>{getContent(languageJSON, 'label_ie_not_supported')}</Typography>
                        </Grid>}
                        <Grid item xs={12} style={{ marginTop: 15 }}>
                            <CustomButton size="large" variant="outlined" style={{ textAlign: 'center', width: '100%' }} color="primary"
                                label={<CopyToClipboard text={locationUrl}><Typography>{getContent(languageJSON, 'label_click_to_copy_url')}</Typography></CopyToClipboard>} />
                        </Grid>
                    </Grid>
                    }

                </Dialog > : null
        )
    }
}

const mapStateToProps = ({ language: { languageJSON } }) => ({
    languageJSON
})

export default connect(mapStateToProps, null)(CheckAppRequirement)
